/* ==========================================================================
   ミタクル イベントページ
   タブ切り替え / カルーセル / エリア絞り込み

   要素への直接バインドではなく document へのイベント委譲で実装している。
   読み込み時点で下部セクションがまだ張り付けられていなかったり、テーマや
   アプリが後から DOM を差し替えたりしてもリスナーが外れないようにするため。
   ========================================================================== */
(function () {
  'use strict';

  // このファイルはイベント一覧 / カレンダー&店舗検索 / 店舗受取商品の 3 セクションから
  // 出力されるため、1 ページに <script> が複数本並ぶ。クラシックスクリプトは同一 URL でも
  // 都度実行されるので、ガードが無いと document のリスナーが本数分だけ登録される。
  // エリアボタンは押すたびに aria-selected を反転する実装のため、登録数が偶数だと
  // 1 クリックで開いて閉じてしまい、絞り込みが無言で動かなくなる
  if (window.__mtcEventInit) return;
  window.__mtcEventInit = true;

  function closest(target, selector) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(selector);
  }

  function sectionRoot(el) {
    return closest(el, '[data-mtc-section]') || document;
  }

  /* --- タブ（開催中 / 近日開催 / 終了したイベント） ---------------------- */

  function selectTab(root, name) {
    root.querySelectorAll('[data-mtc-tab]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-mtc-tab') === name;
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    root.querySelectorAll('[data-mtc-tabpanel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-mtc-tabpanel') === name;
      panel.hidden = !isActive;
      // 非表示中はスクロール量を測れないため、表示に切り替わった側だけ測り直す
      if (isActive) {
        panel.querySelectorAll('[data-mtc-carousel]').forEach(updateNavState);
      }
    });

    syncPickupGroups(name);
  }

  /**
   * 「店舗受け取りができる商品」を、選択中のタブに合わせて切り替える。
   * 商品セクションはイベント一覧とは別セクションなので document 全体から探す。
   */
  function syncPickupGroups(name) {
    var groups = document.querySelectorAll('[data-mtc-pickup-group]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      group.hidden = group.getAttribute('data-mtc-pickup-group') !== name;
      // 非表示中は clientWidth / scrollWidth が 0 になり矢印の活性状態を測れないため、
      // 表示に切り替わった側だけタブパネルと同じように測り直す
      if (!group.hidden) {
        group.querySelectorAll('[data-mtc-carousel]').forEach(updateNavState);
      }
    });
  }

  /* --- エリアから探す ---------------------------------------------------- */

  function selectArea(root, area) {
    root.querySelectorAll('[data-mtc-area]').forEach(function (btn) {
      btn.setAttribute('aria-selected', btn.getAttribute('data-mtc-area') === area ? 'true' : 'false');
    });

    root.querySelectorAll('[data-mtc-areapanel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-mtc-areapanel') !== area;
    });
  }

  /* --- カルーセル -------------------------------------------------------- */

  function updateNavState(carousel) {
    var track = carousel.querySelector('[data-mtc-track]');
    if (!track) return;

    var prev = carousel.querySelector('[data-mtc-prev]');
    var next = carousel.querySelector('[data-mtc-next]');
    // 端数の丸め誤差で押せなくならないよう 1px の余裕を持たせる
    var maxScroll = track.scrollWidth - track.clientWidth - 1;

    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= maxScroll;
  }

  function scrollCarousel(carousel, direction) {
    var track = carousel.querySelector('[data-mtc-track]');
    if (!track) return;
    track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
  }

  function refreshCarousels(scope) {
    (scope || document).querySelectorAll('[data-mtc-carousel]').forEach(updateNavState);
  }

  /* --- イベント委譲 ------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    var tabBtn = closest(event.target, '[data-mtc-tab]');
    if (tabBtn) {
      selectTab(sectionRoot(tabBtn), tabBtn.getAttribute('data-mtc-tab'));
      return;
    }

    var areaBtn = closest(event.target, '[data-mtc-area]');
    if (areaBtn) {
      // 選択済みのエリアをもう一度押したら閉じる
      var area = areaBtn.getAttribute('aria-selected') === 'true' ? '' : areaBtn.getAttribute('data-mtc-area');
      selectArea(sectionRoot(areaBtn), area);
      return;
    }

    var nav = closest(event.target, '[data-mtc-prev], [data-mtc-next]');
    if (nav && !nav.disabled) {
      var carousel = closest(nav, '[data-mtc-carousel]');
      if (carousel) scrollCarousel(carousel, nav.hasAttribute('data-mtc-prev') ? -1 : 1);
    }
  });

  // 左右キーでのタブ移動（WAI-ARIA タブパターン）
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

    var tabBtn = closest(event.target, '[data-mtc-tab]');
    if (!tabBtn) return;

    var tablist = closest(tabBtn, '[data-mtc-tabs]');
    if (!tablist) return;

    var buttons = Array.prototype.slice.call(tablist.querySelectorAll('[data-mtc-tab]'));
    var current = buttons.indexOf(tabBtn);
    if (current === -1) return;

    var step = event.key === 'ArrowRight' ? 1 : -1;
    var next = (current + step + buttons.length) % buttons.length;

    event.preventDefault();
    buttons[next].focus();
    selectTab(sectionRoot(buttons[next]), buttons[next].getAttribute('data-mtc-tab'));
  });

  // scroll はバブリングしないのでキャプチャ段階で拾う
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track || track.nodeType !== 1 || !track.matches('[data-mtc-track]')) return;

    var carousel = closest(track, '[data-mtc-carousel]');
    if (carousel) updateNavState(carousel);
  }, true);

  window.addEventListener('resize', function () { refreshCarousels(); });

  // 矢印の活性状態だけは初期描画が必要（押せるかどうかの見た目のみ）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refreshCarousels(); });
  } else {
    refreshCarousels();
  }

  window.addEventListener('load', function () { refreshCarousels(); });
  document.addEventListener('shopify:section:load', function (event) { refreshCarousels(event.target); });
})();
